import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut, Sparkles, FolderKanban } from "lucide-react";

export default function Billing() {
  const { session, logout } = useAuth();
  if (session === null) return null;
  if (!session) return <Navigate to="/login" replace />;
  if (session.platform_role) return <Navigate to="/platform" replace />;
  if ((session.available_modules || []).length > 0) return <Navigate to="/" replace />;

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="w-full max-w-2xl text-center">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-amber-100 text-amber-600">
          <Sparkles className="h-7 w-7" />
        </div>
        <h1 className="mt-5 font-heading text-3xl font-extrabold">Your trial has lapsed</h1>
        <p className="mt-2 text-slate-500">
          {session.tenant?.name} has no active subscription. Activate a module to get back to work.
        </p>
        <div className="mt-8 grid gap-4 sm:grid-cols-1 max-w-sm mx-auto text-left">
          <PlanCard icon={FolderKanban} color="#4F46E5" name="Data Collection" price="149" />
        </div>
        <p className="mt-6 text-xs text-slate-400">Contact your Firm Admin or platform owner to activate a plan.</p>
        <Button variant="ghost" className="mt-6" data-testid="billing-logout" onClick={logout}>
          <LogOut className="mr-2 h-4 w-4" /> Sign out
        </Button>
      </div>
    </div>
  );
}

function PlanCard({ icon: Icon, color, name, price }) {
  return (
    <div className="rounded-xl border border-slate-200 dark:border-slate-800 p-6 bg-white dark:bg-slate-900">
      <div className="flex h-10 w-10 items-center justify-center rounded-lg" style={{ backgroundColor: color + "22" }}>
        <Icon className="h-5 w-5" style={{ color }} />
      </div>
      <div className="mt-4 font-heading text-lg font-bold">{name}</div>
      <div className="mt-1 text-2xl font-extrabold">${price}<span className="text-sm font-normal text-slate-400">/mo</span></div>
    </div>
  );
}
